import z from "zod";

const remiAppValues = [
  "HOMEOWNER_PORTAL",
  "JOB_SCHEDULER",
  "ODDJOB_API",
  "PDF_RENDERER",
  "PLAYGROUND", // Possible remove in favor of a frontend error
  "PARTNER_API", // Possible remove in favor of a frontend error
  "REMI_NEXTJS",
  "SUNRUN_AUTOMATIONS",
  "THUMBNAIL_LAMBDA",
  "TRPC_ROUTER",
  "WEBHOOK_PROCESSOR",
  "WESTHILL_INTEGRATION",
  "MOBILE_API",
  "RDCL_INTEGRATION",
  "AMFAM_INTEGRATION",
  "ENSITE_INTEGRATION",
  "INSPECTIFY_INTEGRATION",
  "SUNRUN_INTEGRATION",
] as const;
const remiAppSchema = z.enum(remiAppValues);
export const RemiApp = remiAppSchema.enum;
export type RemiApp = z.infer<typeof remiAppSchema>;

export type ErrorDetails = {
  sentryDescription: string;
  remiHttpCode: RemiHttpCode;
};

const httpCodes = [
  "BAD_REQUEST",
  "UNAUTHORIZED",
  "FORBIDDEN",
  "NOT_FOUND",
  "CONFLICT",
  "TOO_MANY_REQUESTS",
  "INTERNAL_SERVER_ERROR",
] as const;
const httpCodeSchema = z.enum(httpCodes);
export const RemiHttpCode = httpCodeSchema.enum;
export type RemiHttpCode = z.infer<typeof httpCodeSchema>;

export const remiHttpCodeToNumber = {
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  CONFLICT: 409,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
} as const satisfies Record<RemiHttpCode, number>;

export type RemiHttpStatusCode = (typeof remiHttpCodeToNumber)[RemiHttpCode];
